export default __webpack_public_path__ + "static/media/weekend1.f89dc521.png";